import { useMemo } from 'react'

import { Input } from 'core-components/library/inputs'
import { ValidateInput } from 'core-components/library/validation'
import { IProperties } from 'core-components/sitebuilder/propertygenerator'
import { isPathString } from 'core-components/sitebuilder/propertygenerator/validators/isPathString'

import { IExtendedProperties } from '../../models/IExtendedProperties'
import { TPropertiesValue } from '../../models/IProperties'

interface IDefaultRender {
  property: IProperties
  value: string
  onChange: (newValue: string) => void
  withInnerValidator?: boolean
  label?: string
}

export const DefaultRender = ({
  property,
  value = '',
  label,
  withInnerValidator,
  onChange,
}: IDefaultRender) => {
  const calculatedLabel = useMemo(() => {
    if (label) {
      return label
    }
    if (property.needLoad) {
      return 'Path to TS module'
    }
    return property.name
  }, [label, property.name, property.needLoad])

  const inputProps = {
    className: 'content-full-width',
    label: calculatedLabel,
    value,
    onChange,
  }

  if (property.needLoad && withInnerValidator) {
    return (
      <ValidateInput
        key={property.name}
        checkFn={(checkValue) => {
          return isPathString(checkValue, {
            required: property.required,
            needLoad: property.needLoad,
          })
        }}
        {...inputProps}
      />
    )
  }

  return <Input key={property.name} {...inputProps} />
}
